<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="fm-1">‘As an artist, you should aspire to</p>
<p class="fm">capture the atmosphere, mood, and</p>
<p class="fm">that vital impression of depth and</p>
<p class="fm">distance in your work. Aim to make the</p>
<p class="fm">viewer feel involved in the scene, as</p>
<p class="fm">though they could walk into it.’</p>
<p class="fm"><span class="bold">Geoff Kersey</span></p>
<div class="img_container">
<img alt="image" src="images/f001-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Author.vue?b2e7e068